import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { BedDouble, Bath, Square } from 'lucide-react';
const propertiesData = [{
  image: 'https://m1.cbhomes.com/p/62/7068119/E148892EC21B4f3/pdl23tp.webp',
  price: '$424,900',
  address: '738 County Rd B E, Maplewood, MN 55117',
  beds: 5,
  baths: 1,
  sqft: '2,224',
  link: 'https://www.coldwellbankerhomes.com/mn/maplewood/738-county-road-b-e/pid_71067830/'
}, {
  image: 'https://m1.cbhomes.com/p/62/7097659/fe3B8694270c461/full.webp',
  price: '$450,000',
  address: '11519 22nd Cir NE, Saint Michael, MN 55376',
  beds: 4,
  baths: 2,
  sqft: '2,209',
  link: 'https://www.coldwellbankerhomes.com/mn/saint-michael/11519-22nd-circle-ne/pid_72134529/'
}, {
  image: 'https://m1.cbhomes.com/p/62/6809197/69e2e112EBa24A1/pdl23tp.webp',
  price: '$420,000',
  address: '255 County Rd C2 W, Roseville, MN 55113',
  beds: 4,
  baths: 1,
  sqft: '1,320',
  link: 'https://www.coldwellbankerhomes.com/mn/roseville/255-county-road-c2-w/pid_68157716/'
}];
export const Properties = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].properties;
  return <FadeInSection id="properties" className="w-full bg-white py-24 lg:py-32" data-id="element-216" data-mp="o38nql0dilkz">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-217" data-mp="j68j8ej69qvz">
        <div className="flex flex-col items-center text-center mb-20" data-id="element-218" data-mp="e7nrz4lwehjo">
          <span className="eyebrow mb-4" data-id="element-219" data-mp="98awjvgyo25h">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-[#1a1a1a]" data-id="element-220" data-mp="96rfi2nhdn2n">
            {t.headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16" data-id="element-221" data-mp="85wy7i0e81v">
          {propertiesData.map((prop, index) => <div key={index} className="group cursor-pointer flex flex-col" data-id="element-222" data-mp="1zjfh31u07f7f" data-mpi={index}>
              <div className="relative h-[260px] w-full overflow-hidden mb-6" data-id="element-223" data-mp="1uldyei0hphwh">
                <img src={prop.image} alt={prop.address} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" data-id="element-224" data-mp="2dqiri3vjgvc4" />
                <div className="absolute top-4 left-4" data-id="element-225" data-mp="24qnavjj7s84p">
                  <span className="text-[#c9a96e] uppercase p-2 text-[11px] tracking-[0.15em]" data-id="element-226" data-mp="29oouq6ogsbh8">
                    {t.status}
                  </span>
                </div>
              </div>

              <div className="flex flex-col flex-grow" data-id="element-227" data-mp="2xcf05wboeiwg">
                <h3 className="font-serif-display text-3xl font-medium text-[#1a1a1a] mb-2" data-id="element-228" data-mp="31ejxp658vzod">
                  {prop.price}
                </h3>
                <p className="body-text text-sm text-[#1a1a1a]/70 mb-6 min-h-[48px]" data-id="element-229" data-mp="2sf6jy1a38oxu">
                  {prop.address}
                </p>

                <div className="flex items-center justify-between border-t border-b border-[#1a1a1a]/10 py-4 mb-8" data-id="element-230" data-mp="1bzvhettj9xl2">
                  <div className="flex items-center space-x-2 text-[#1a1a1a]/80" data-id="element-231" data-mp="1h1kx4mrpazfh">
                    <BedDouble size={18} strokeWidth={1.5} data-id="element-232" data-mp="19ffql7f68g31" />
                    <span className="text-sm" data-id="element-233" data-mp="14he2u96svsl8">{prop.beds} Beds</span>
                  </div>
                  <div className="flex items-center space-x-2 text-[#1a1a1a]/80" data-id="element-234" data-mp="1ih6se16lc2rm">
                    <Bath size={18} strokeWidth={1.5} data-id="element-235" data-mp="1if2p9lgin7se" />
                    <span className="text-sm" data-id="element-236" data-mp="1dj59phd2u5go">{prop.baths} Baths</span>
                  </div>
                  <div className="flex items-center space-x-2 text-[#1a1a1a]/80" data-id="element-237" data-mp="prq6lmdh7k4d">
                    <Square size={18} strokeWidth={1.5} data-id="element-238" data-mp="lrfzg6dy6nnx" />
                    <span className="text-sm" data-id="element-239" data-mp="lotft8ds8hpc">{prop.sqft} SqFt</span>
                  </div>
                </div>

                <a href={prop.link} target="_blank" rel="noopener noreferrer" className="w-full py-3 border border-[#c9a96e] text-[#c9a96e] uppercase tracking-widest text-xs hover:bg-[#c9a96e] hover:text-white transition-colors duration-300 mt-auto text-center block" data-id="element-240" data-mp="zk5nshgy84o7">
  {t.viewBtn}
</a>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-241" data-mp="fqytslrvcpbd">
  <a href="https://www.coldwellbankerhomes.com/mn/minneapolis/agent/cenia-badillo/aid_228164/listings/" target="_blank" rel="noopener noreferrer" className="px-10 py-4 border border-[#c9a96e] text-[#c9a96e] uppercase tracking-widest text-sm hover:bg-[#c9a96e] hover:text-white transition-colors duration-300" data-id="element-242" data-mp="fnt71d6ppzit">
    {t.seeAllBtn}
  </a>
</div>
      </div>
    </FadeInSection>;
};